module.exports = __webpack_public_path__ + "img/1-2-p4.7d836666.svg";